import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    clientId: false
  },
  mutations: {
    setClientId (state, clientId) {
      state.clientId = clientId
    },
    unsetClientId (state) {
      state.clientId = false
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js